export default "__VITE_ASSET__Dlj1uIJW__"